var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-ui-logo"},[_c('canvas',{ref:"canvas",attrs:{"width":"960","height":"540"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }